import OfficialIngredients from './OfficialIngredients'

export default OfficialIngredients
